import {
  Box, Button, Card, CardContent, CircularProgress, Grid, Typography
} from '@material-ui/core';
import { useAsync } from 'hooks/useAsync';
import { ClientDestinationDetails, DestinationType } from 'models/ClientDestinationDetails';
import React from 'react';
import { clientDestinationService } from 'services/clientDestinationService';

interface IClientDestinationVoteProps {
  details: ClientDestinationDetails;
}

const Row = ({ label, content }: {label?: string, content?:string}) => (
  <Grid container>
    <Grid item md={3}>
      <Typography variant="body2" align="right">
        {label}
      </Typography>
    </Grid>
    <Grid item md={9}>
      <Typography variant="body1" style={{ wordBreak: 'break-all' }}>
        {content}
      </Typography>
    </Grid>
  </Grid>
);

const getTitleByType = (type: DestinationType): string => {
  switch (type) {
    case DestinationType.WITHDRAWAL:
      return 'Approval of new withdrawal address';
    case DestinationType.NEWOWNER_PUBLICKEY:
      return 'Approval of new publickey for change of ownership';
    case DestinationType.TRANSACTION_SENDER:
      return 'Approval of new transaction sender address';
    default:
      return '';
  }
};

export const ClientDestinationVote = ({ details }: IClientDestinationVoteProps) => {
  const notificationId = details.notificationId;
  const reject = useAsync(() => clientDestinationService.rejectClientDestination(notificationId, details.blockchain));
  const approve = useAsync(() => clientDestinationService.approveClientDestination(notificationId, details.blockchain));

  const shouldDisable = approve.isLoading || approve.isSuccess || reject.isLoading || reject.isSuccess;

  return (
    <>
      <Box display="flex" pb={4}>
        <Typography variant="h3">
          {getTitleByType(details.destinationType)}
        </Typography>
      </Box>
      <Card>
        <CardContent>
          <Grid container>
            <Grid item md={12}><Typography variant="h5">Details</Typography></Grid>
          </Grid>
          <Box pt={2}>
            <Row label="Client" content={details.companyName} />
            <Row label="Address" content={details.destinationPublicKey} />
            <Row label="Verified Label" content={details.verifiedLabel} />
            <Row label="Blockchain" content={details.blockchain} />
            <Row label="State" content={details.state} />
          </Box>
          <Box pt={2}>
            <Grid container>
              <Grid item md={3} />
              <Grid item md={9}>
                {
                  approve.isSuccess || reject.isSuccess
                    ? <Typography variant="caption" color="textPrimary">Thanks for voting, your vote has been registered</Typography>
                    : (
                      <>
                        <Box display="flex" flexDirection="row">
                          <Box>
                            <Button
                              disabled={shouldDisable}
                              variant="contained"
                              color="secondary"
                              onClick={() => reject.exec()}
                              endIcon={(reject.isLoading) && <CircularProgress size="1rem" color="secondary" style={{ margin: 0 }} />}
                            >
                              Reject
                            </Button>
                          </Box>
                          <Box pl={2}>
                            <Button
                              disabled={shouldDisable}
                              variant="contained"
                              color="primary"
                              onClick={() => approve.exec()}
                              endIcon={(approve.isLoading) && <CircularProgress size="1rem" color="secondary" style={{ margin: 0 }} />}
                            >
                              Approve
                            </Button>
                          </Box>
                        </Box>
                        {approve.isError && approve.error
                          && <Typography variant="caption" color="primary">{approve?.error?.data[0]?.description}</Typography>}
                        {reject.isError && reject.error
                          && <Typography variant="caption" color="primary">{reject?.error?.data[0]?.description}</Typography>}
                      </>
                    )
                  }
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
